import { render, staticRenderFns } from "./CustomerIGO.vue?vue&type=template&id=b9c96d2e&scoped=true"
import script from "./CustomerIGO.vue?vue&type=script&lang=js"
export * from "./CustomerIGO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c96d2e",
  null
  
)

export default component.exports